
import { observable, action, runInAction } from 'mobx';
import { message } from "antd";
import moment from 'moment';
import { setColumn, setYCategory } from "@/method/analysis";
import { getJson } from '../method';
import Echarts from "echarts";

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

const label = {
    "formatter": "{c}%",
    "show": true,
    position: 'inner',
    fontWeight: "bold",
    fontSize: 14
};

const defaultDate = moment().format('D') <= 10 ?
    moment().subtract(2, 'month').format('YYYY-MM') :
    moment().subtract(1, 'month').format('YYYY-MM');

class store {
    @observable data = {};
    @observable loading = false;
    @observable date = defaultDate;

    @action
    getData = async () => {
        runInAction(() => {
            this.loading = true;
        });
        try {
            const month = moment(this.date).format('M');
            const year = moment(this.date).format('YYYY');

            let j = await fetch(`/performanceAll?month=${month}&year=${year}`, { credentials: 'include' })
            let data = await j.json();
            const { mtd = [], ytd = [], seasonal = [] } = data.data;
            const revenueData = {
                color: ['#CD4B3F', '#3C5764', '#76A9B6'],
                id: "revenue",
                dataX: ['Rooms Revenue % \n 客房收入占比', 'F&B Revenue % \n 餐饮收入占比', 'Other Revenue % \n 其他部门收入占比'],
                dataY: [{
                    name: "Area Data 区域数据",
                    data: [getJson([0, 'area'], mtd), getJson([1, 'area'], mtd), getJson([2, 'area'], mtd)]
                }, {
                    name: "Revenue Range Data 收入区间数据",
                    data: [getJson([0, 'interval'], mtd), getJson([1, 'interval'], mtd), getJson([2, 'interval'], mtd)]
                }, {
                    name: "Hotel Data 酒店数据",
                    data: [getJson([0, 'hotel'], mtd), getJson([1, 'hotel'], mtd), getJson([2, 'hotel'], mtd)]
                }]
            };
            setColumn(revenueData, false);

            const purchase = {
                color: ['#CD4B3F', '#3C5764', '#76A9B6'],
                id: "purchase",
                dataX: ['Top 15 Vs. Total Purchase 前15位采购占总额比'],
                dataY: [{
                    name: "Area Data 区域数据",
                    data: [getJson([15, 'area'], mtd)]
                }, {
                    name: "Revenue Range Data 收入区间数据",
                    data: [getJson([15, 'interval'], mtd)]
                }, {
                    name: "Hotel Data 酒店数据",
                    data: [getJson([15, 'hotel'], mtd)]
                }]
            };
            setColumn(purchase, false);


            const cost = {
                color: ['#00C6BD', '#42585D', '#FF605F'],
                id: "RestaurantCost",
                dataY: ['Banquet \n  宴会', 'Chinese \n  Restaurant \n  中餐厅', 'Coffee Shop \n  咖啡厅 '],
                dataX: [{
                    name: "Area Data 区域数据",
                    data: [getJson([11, 'area'], mtd), getJson([9, 'area'], mtd), getJson([7, 'area'], mtd),]
                }, {
                    name: "Revenue Range  Data 收入区间数据",
                    data: [getJson([11, 'interval'], mtd), getJson([9, 'interval'], mtd), getJson([7, 'interval'], mtd)]
                }, {
                    name: "Hotel Data 酒店数据",
                    data: [getJson([11, 'hotel'], mtd), getJson([9, 'hotel'], mtd), getJson([7, 'hotel'], mtd)]
                }]
            };
            setYCategory(cost, false);

            const RestaurantIncome = {
                color: ['#00C6BD', '#42585D', '#FF605F'],
                id: "RestaurantIncome",
                dataY: ['Banquet \n  宴会', 'Chinese \n  Restaurant \n  中餐厅', 'Coffee Shop \n  咖啡厅 '],
                dataX: [{
                    name: "Area Data 区域数据",
                    data: [getJson([10, 'area'], mtd), getJson([8, 'area'], mtd), getJson([6, 'area'], mtd)]
                }, {
                    name: "Revenue Range  Data 收入区间数据",
                    data: [getJson([10, 'interval'], mtd), getJson([8, 'interval'], mtd), getJson([6, 'interval'], mtd)]
                }, {
                    name: "Hotel Data 酒店数据",
                    data: [getJson([10, 'hotel'], mtd), getJson([8, 'hotel'], mtd), getJson([6, 'hotel'], mtd)]
                }]

            };
            setYCategory(RestaurantIncome, false);

            runInAction(() => {
                this.loading = false;
                this.data = data.data;
            });

            this.data = data.data;

            this.setRoom(data.data);

            this.setFood(data.data);

        } catch (error) {
            runInAction(() => {
                this.loading = false;
            });
            console.error(error);
            message.error('数据获取错误!');
        }
    }

    setRoom = (data, isOnResize) => {
        const myChart = Echarts.init(document.getElementById('room'));
        myChart.resize();
        if (isOnResize) {
            return
        }
        let room_data = (data.mtd || []).find(item => item.name == "Rooms Dept Profit % 客房部门利润率") || {};
        const color = ['#fb734e', '#e32f46', '#94d96c', '#0bbcb7', '#1a9bfc', '#7049f0'];
        const dataStyle = {
            normal: {
                label: {
                    show: false
                },
                labelLine: {
                    show: false
                },
                shadowBlur: 40,
                borderWidth: 10,
                shadowColor: 'rgba(0, 0, 0, 0)' //边框阴影
            }
        };
        const placeHolderStyle = {
            normal: {
                color: '#EFF0F0',
                label: {
                    show: false
                },
                labelLine: {
                    show: false
                }
            },
            emphasis: {
                color: 'rgba(239, 240, 240, 0.8)'
            }
        };
        const option = {
            backgroundColor: '#fff',
            title: {
                text: '',
                x: 'center',
                y: 'center',
                textStyle: {
                    fontWeight: 'normal',
                    fontSize: 24,
                    color: "#fff",
                }
            },
            tooltip: {
                trigger: 'item',
                show: true,
                formatter: "{b} : <br/>{d}%",
                backgroundColor: 'rgba(0,0,0,0.7)', // 背景
                padding: [8, 10], //内边距
                extraCssText: 'box-shadow: 0 0 3px rgba(255, 255, 255, 0.4);', //添加阴影
            },
            legend: {
                left: 'center',
                bottom: '0',
                itemGap: 20,
                data: ['Hotel Data 酒店数据', 'Revenue Range Data 收入区间数据', 'Area Data 区域数据', '04', '05', '06'],
                textStyle: {
                    color: '#fft'
                }
            },

            series: [{
                name: 'Line 1',
                type: 'pie',
                clockWise: true,
                radius: [136, 176],
                center: ['50%', '45%'],
                itemStyle: dataStyle,
                hoverAnimation: false,
                startAngle: 90,
                "hoverAnimation": false,
                "z": 3,
                data: [{
                    value: (Number(room_data.area || 0) * 100).toFixed(1),
                    name: 'Area Data 区域数据',
                    itemStyle: {
                        normal: {
                            color: 'rgba(178, 204, 228, 1)'

                        }
                    },
                    label
                },
                {
                    value: (Number(room_data.area || 0) * 100) < 0 ? (2 * Math.abs((Number(room_data.area || 0) * 100).toFixed(1))) : (100 - Number(room_data.area || 0) * 100),
                    name: '',
                    tooltip: {
                        show: false
                    },
                    labelLine: { show: false },
                    itemStyle: placeHolderStyle
                }]
            },
            {
                name: 'Line 2',
                type: 'pie',
                clockWise: true,
                radius: [90, 130],
                center: ['50%', '45%'],
                itemStyle: dataStyle,
                hoverAnimation: false,
                startAngle: 90,
                "z": 4,
                "hoverAnimation": false,
                data: [{
                    value: (Number(room_data.interval || 0) * 100).toFixed(1),
                    name: 'Revenue Range Data 收入区间数据',
                    itemStyle: {
                        normal: {
                            color: 'rgba(112, 164, 213, 1)'
                        }
                    },
                    label
                },
                {
                    value: (Number(room_data.interval || 0) * 100) < 0 ? (2 * Math.abs((Number(room_data.interval || 0) * 100).toFixed(1))) : (100 - Number(room_data.interval || 0) * 100),
                    name: '',
                    tooltip: {
                        show: false
                    },
                    labelLine: { show: false },
                    itemStyle: placeHolderStyle
                },
                ]
            },
            {
                name: 'Line 3',
                type: 'pie',
                clockWise: true,
                radius: [50, 84],
                center: ['50%', '45%'],
                itemStyle: dataStyle,
                hoverAnimation: false,
                startAngle: 90,
                "hoverAnimation": false,
                "z": 5,
                data: [{

                    value: (Number(room_data.hotel || 0) * 100).toFixed(1),
                    name: 'Hotel Data 酒店数据',

                    itemStyle: {
                        normal: {
                            color: 'rgba(33, 114, 188, 1)'
                        }
                    },
                    label

                },
                {
                    value: (Number(room_data.hotel || 0) * 100) < 0 ? (2 * Math.abs((Number(room_data.hotel || 0) * 100).toFixed(1))) : (100 - Number(room_data.hotel || 0) * 100),
                    name: '',
                    tooltip: {
                        show: false
                    },
                    labelLine: { show: false },
                    itemStyle: placeHolderStyle
                },
                ]
            }
            ]
        };
        myChart.setOption(option);
    }

    setFood = (data, isOnResize) => {
        const myChart = Echarts.init(document.getElementById('food'));
        if (isOnResize) {
            return
        }
        let food_data = (data.mtd || []).find(item => item.name == "F&B Dept Profit % 餐饮部门利润率") || {};
        const dataStyle = {
            normal: {
                label: {
                    show: false
                },
                labelLine: {
                    show: false
                },
                shadowBlur: 40,
                borderWidth: 10,
                shadowColor: 'rgba(0, 0, 0, 0)' //边框阴影
            }
        };
        const placeHolderStyle = {
            normal: {
                color: '#EFF0F0',
                label: {
                    show: false
                },
                labelLine: {
                    show: false
                }
            },
            emphasis: {
                color: 'rgba(239, 240, 240, 0.8)'
            }
        };
        const option = {
            backgroundColor: '#fff',
            title: {
                text: '',
                x: 'center',
                y: 'center',
                textStyle: {
                    fontWeight: 'normal',
                    fontSize: 24,
                    color: "#fff",
                }
            },
            tooltip: {
                trigger: 'item',
                show: true,
                formatter: "{b} : <br/>{d}%",
                backgroundColor: 'rgba(0,0,0,0.7)', // 背景
                padding: [8, 10], //内边距
                extraCssText: 'box-shadow: 0 0 3px rgba(255, 255, 255, 0.4);', //添加阴影
            },
            legend: {
                // orient: 'vertical',
                // icon: 'circle',
                left: 'center',
                // top: '20',
                bottom: '0',
                itemGap: 20,
                data: ['Hotel Data 酒店数据', 'Revenue Range Data 收入区间数据', 'Area Data 区域数据', '04', '05', '06'],
                textStyle: {
                    color: '#fft'
                }
            },

            series: [{
                name: 'Line 1',
                type: 'pie',
                clockWise: true,
                radius: [136, 176],
                center: ['50%', '45%'],
                itemStyle: dataStyle,
                hoverAnimation: false,
                startAngle: 90,
                "hoverAnimation": false,
                "z": 3,
                data: [{
                    value: (Number(food_data.area || 0) * 100).toFixed(1),
                    name: 'Area Data 区域数据',
                    itemStyle: {
                        normal: {

                            color: 'rgba(240, 179, 190, 1)'
                        }
                    },

                    label
                },
                {
                    value: (Number(food_data.area || 0) * 100) < 0 ? (2 * Math.abs((Number(food_data.area || 0) * 100).toFixed(1))) : (100 - Number(food_data.area || 0) * 100),
                    name: '',
                    tooltip: {
                        show: false
                    },
                    labelLine: { show: false },
                    itemStyle: placeHolderStyle
                }]
            },
            {
                name: 'Line 2',
                type: 'pie',
                clockWise: true,
                radius: [90, 130],
                center: ['50%', '45%'],
                itemStyle: dataStyle,
                hoverAnimation: false,
                startAngle: 90,
                "z": 4,
                "hoverAnimation": false,
                data: [{
                    value: (Number(food_data.interval || 0) * 100).toFixed(1),
                    name: 'Revenue Range Data 收入区间数据',
                    itemStyle: {
                        normal: {
                            color: 'rgba(202, 113, 186, 1)'
                        }
                    },
                    label
                },
                {
                    value: (Number(food_data.interval || 0) * 100) < 0 ? (2 * Math.abs((Number(food_data.interval || 0) * 100).toFixed(1))) : (100 - Number(food_data.interval || 0) * 100),
                    name: '',
                    tooltip: {
                        show: false
                    },
                    labelLine: { show: false },
                    itemStyle: placeHolderStyle
                },
                ]
            },
            {
                name: 'Line 3',
                type: 'pie',
                clockWise: true,
                radius: [50, 84],
                center: ['50%', '45%'],
                itemStyle: dataStyle,
                hoverAnimation: false,
                startAngle: 90,
                "hoverAnimation": false,
                "z": 5,
                data: [{
                    value: (Number(food_data.hotel || 0) * 100).toFixed(1),
                    name: 'Hotel Data 酒店数据',
                    itemStyle: {
                        normal: {
                            color: 'rgba(117, 54, 164, 1)'
                        }
                    },
                    label


                },
                {
                    value: (Number(food_data.hotel || 0) * 100) < 0 ? (2 * Math.abs((Number(food_data.hotel || 0) * 100).toFixed(1))) : (100 - Number(food_data.hotel || 0) * 100),
                    name: '',
                    tooltip: {
                        show: false
                    },
                    labelLine: { show: false },
                    itemStyle: placeHolderStyle
                },
                ]
            }
            ]
        };
        myChart.setOption(option);
    }

    onResize = () => {
        this.setRoom(this.data, true);
        this.setFood(this.data, true)
    }
}

const analysis = new store();
export default analysis



// WEBPACK FOOTER //
// ./src/store/analysis.js